var ApiUtil = require('./api-util')

exports.commentIndex = function(campaignId, limit, offset) {
  var data = {
    campaign_id: campaignId,
    limit: limit
  }
  if (offset != null) {
    data.offset = offset
  }

  return ApiUtil.request('get', '/api/campaign_comment/index.json', data)
}

exports.commentRemove = function(commentId) {
  var data = {'data[CampaignComment][id]': commentId}
  return ApiUtil.request('post', '/api/campaign_comment/remove.json', data)
}



// WEBPACK FOOTER //
// ./webroot/js/api/campaign.js